var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoveredSpeakerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 1.25024L4 4.25024H1V8.75024H4L7.75 11.7502V1.25024Z",
    stroke: "#003F7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8028 1.19751C15.2088 2.60397 15.9987 4.51128 15.9987 6.50001C15.9987 8.48874 15.2088 10.3961 13.8028 11.8025M11.1553 3.84501C11.8583 4.54824 12.2532 5.50189 12.2532 6.49626C12.2532 7.49063 11.8583 8.44428 11.1553 9.14751",
    stroke: "#003F7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoveredSpeakerIcon);
export default __webpack_public_path__ + "static/media/hovered-speaker-icon.496d16450109b8b829a5450d90f53620.svg";
export { ForwardRef as ReactComponent };